import * as actionTypes from 'constants/ActionTypes';

export function getAreas() {
    return {
        type: actionTypes.GET_AREAS.REQUEST,
    };
}

export function getArea(areaId) {
    return {
        type: actionTypes.GET_AREA.REQUEST,
        areaId,
    };
}

export function deleteArea(item) {
    return {
        type: actionTypes.DELETE_AREA.REQUEST,
        item,
    };
}

export function saveArea(item) {
    return {
        type: actionTypes.SAVE_AREA,
        item,
    };
}

export function updateAreaSuggestions(suggestions) {
    return {
        type: actionTypes.UPDATE_AREA_SUGGESTIONS,
        suggestions,
    };
}

export function updateAreaAlt(item) {
    return {
        type: actionTypes.UPDATE_AREA_ALT.REQUEST,
        item,
    };
}

export function updateArea(item) {
    return {
        type: actionTypes.UPDATE_AREA.REQUEST,
        item,
    };
}

export function searchArea(search) {
    return {
        type: actionTypes.SEARCH_AREA,
        search,
    };
}

export function createArea(item) {
    return {
        type: actionTypes.CREATE_AREA.REQUEST,
        item,
    };
}

export function removeAreaChild(parentId, childId) {
    return {
        type: actionTypes.REMOVE_AREA_CHILD.REQUEST,
        parentId,
        childId,
    };
}



// WEBPACK FOOTER //
// ./app/actions/regions/areas.js